import moment from "moment";
import "moment-duration-format";
import i18n from "i18n";
import { isTypeRelativeWithStartOnly } from "views/typeGuards/timeRange";
import { preciseDifference } from "util/DateTime";
export const readableRange = (timerange, fieldName, placeholder) => {
  const rangeAsSeconds = timerange == null ? void 0 : timerange[fieldName];
  const allTimeLabel = i18n.t("time_range.all_time", { ns: "search", defaultValue: "All Time" });
  const nowLabel = i18n.t("time_range.now", { ns: "search", defaultValue: "Now" });
  const defaultFallback = fieldName === "to" ? nowLabel : allTimeLabel;
  const fallback = placeholder != null ? placeholder : defaultFallback;
  if (!rangeAsSeconds) {
    return fallback;
  }
  const reference = moment();
  const dateAgo = moment(reference).subtract(rangeAsSeconds, "seconds");
  const rangeTimespan = preciseDifference(dateAgo, reference, { ago: true });
  return i18n.t("time_range.range_ago", { ns: "search", time: rangeTimespan, defaultValue: "{{time}} ago" });
};
const relativeTimeRangeToString = (timerange) => {
  const nowLabel = i18n.t("time_range.now", { ns: "search", defaultValue: "Now" });
  const allTimeLabel = i18n.t("time_range.all_time", { ns: "search", defaultValue: "All Time" });
  if (isTypeRelativeWithStartOnly(timerange)) {
    if (timerange.range === 0) {
      return allTimeLabel;
    }
    return `${readableRange(timerange, "range")} - ${nowLabel}`;
  }
  return `${readableRange(timerange, "from")} - ${readableRange(timerange, "to")}`;
};
const absoluteTimeRangeToString = (timerange, localizer = (dateTime) => dateTime) => {
  const { from, to } = timerange;
  return `${localizer(from)} - ${localizer(to)}`;
};
const keywordTimeRangeToString = (timerange) => timerange.keyword;
const TimeRangeToString = (timerange, localizer) => {
  const { type } = timerange || {};
  switch (type) {
    case "relative":
      return relativeTimeRangeToString(timerange);
    case "absolute":
      return absoluteTimeRangeToString(timerange, localizer);
    case "keyword":
      return keywordTimeRangeToString(timerange);
    default: {
      return "";
    }
  }
};
export default TimeRangeToString;
